module.exports = __webpack_public_path__ + "90658b41f4c061ba6731ab1baaebfd5a.svg";